import {
  Dialog as KendoDialog,
  DialogProps as KendoDialogProps,
} from '@progress/kendo-react-dialogs';
import _ from 'lodash';
import React, { PropsWithChildren, ReactNode, useEffect } from 'react';
import ClickOutside from './ClickOutside';

interface DialogProps {
  showCloseIcon?: boolean;
  closeDialog?: () => void;
  closeOnClickOutside?: boolean;
  className?: string;
  headerContent?: ReactNode;
  dialogContentRef?: React.Ref<any>;
}

export default function Dialog(
  props: PropsWithChildren<DialogProps & KendoDialogProps>,
) {
  const {
    children,
    showCloseIcon,
    closeOnClickOutside,
    closeDialog,
    headerContent,
    dialogContentRef,
  } = props;

  useEffect(() => {
    document.body.classList.add('modal-open');

    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  const dialogContent = (
    <div ref={dialogContentRef}>
      {showCloseIcon && (
        <div className="dialog-header">
          {headerContent}
          <button
            onClick={() => closeDialog?.()}
            className="btn dialog-close"
          ></button>
        </div>
      )}
      <div className="dialog-container">{children}</div>
    </div>
  );

  return (
    <KendoDialog
      className={props.className}
      {..._.omit(
        props,
        'showCloseIcon',
        'closeDialog',
        'closeOnClickOutside',
        'headerContent',
      )}
    >
      {closeOnClickOutside ? (
        <ClickOutside onClickOutside={() => closeDialog?.()}>
          {dialogContent}
        </ClickOutside>
      ) : (
        dialogContent
      )}
    </KendoDialog>
  );
}

Dialog.defaultProps = {
  showCloseIcon: false,
  closeOnClickOutside: false,
};
